export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-06.7dcc4704.jpg";